import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import api from "../../../utils/api";
import {
  editUserdata,
  empty,
  getUserdata,
  showToast,
} from "../../../helper/generalHelper";
import { Link } from "react-router-dom";
import { FaStore } from "react-icons/fa";

const BusinessModal = () => {
  const [currentBusiness, setCurrentBusiness] = useState({});
  const [selected, setSelected] = useState("");
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const locked = empty(getUserdata("restaurantId"));

  useEffect(() => {
    fetchBusinesses();
  }, []);

  useEffect(() => {
    const sidebar = document.getElementById("sidebar-content");

    if (isModalOpen) {
      if (sidebar) sidebar.style.overflow = "hidden";
      fetchBusinesses(); // refresh list when modal opens
    } else {
      if (sidebar) sidebar.style.overflow = "auto";
    }

    return () => {
      if (sidebar) sidebar.style.overflow = "auto";
    };
  }, [isModalOpen]);

  const fetchBusinesses = async () => {
    try {
      setLoading(true);
      const res = await api.get("restaurant/restaurant/all");
 
      editUserdata(
        "restaurantId",
        res.data?.current_restaurant_id || null
      );

      const allBusinesses = res.data?.reataurants || [];
      const primaryBusinesses = allBusinesses.filter(b => !b.parent_id || b.parent_id === "");
      setBusinesses(primaryBusinesses);
      const activeId = getUserdata("restaurantId") || res.data?.current_restaurant_id;
      if (activeId) {
        setSelected(activeId);
        const currentBiz = allBusinesses.find((b) => b.id === activeId);
        setCurrentBusiness(currentBiz);

        if (currentBiz) {
          localStorage.setItem("restaurantImage", currentBiz.restaurant_images?.[0] || "");
          try {
            const currencyRes = await api.get("restaurant/currency/all");
            if (currencyRes.success && Array.isArray(currencyRes.data)) {
              const matchedCurrency = currencyRes.data.find(
                (c) => String(c.id) === String(currentBiz.currency_id)
              );
              if (matchedCurrency) {
                localStorage.setItem("currency", matchedCurrency.code || "INR");
              } else {
                localStorage.setItem("currency", "INR");
              }
            }
          } catch (currencyErr) {
            console.error("Failed to load currencies:", currencyErr);
            localStorage.setItem("currency", "INR");
          }

          const dec = currentBiz.decimal_places !== undefined && currentBiz.decimal_places !== null 
            ? Number(currentBiz.decimal_places) 
            : 2;
          const safeDec = [2, 3, 4].includes(dec) ? dec : 2;
          localStorage.setItem("currencyDecimals", safeDec);
        }
      }
    } catch (error) {
      console.error("Error fetching businesses:", error);
    } finally {
      setLoading(false);
    }
  };

  
  // ✅ fixed handleConfirm
  const handleConfirm = async () => {
    if (!selected) {
      showToast({ success: false, message: "Please select a business first" });
      return;
    }

    try {
      const res = await api.get(`restaurant/restaurant/switch?id=${selected}`);

      if (res.success) {
        editUserdata("restaurantId", selected);

        // Pre-resolve currency and decimal settings for the selected business
        const selectedBiz = businesses.find((b) => b.id === selected);
        if (selectedBiz) {
          localStorage.setItem("restaurantImage", selectedBiz.restaurant_images?.[0] || "");
          try {
            const currencyRes = await api.get("restaurant/currency/all");
            if (currencyRes.success && Array.isArray(currencyRes.data)) {
              const matchedCurrency = currencyRes.data.find(
                (c) => String(c.id) === String(selectedBiz.currency_id)
              );
              if (matchedCurrency) {
                localStorage.setItem("currency", matchedCurrency.code || "INR");
              } else {
                localStorage.setItem("currency", "INR");
              }
            }
          } catch (currencyErr) {
            console.error("Failed to load currencies:", currencyErr);
            localStorage.setItem("currency", "INR");
          }

          const dec = selectedBiz.decimal_places !== undefined && selectedBiz.decimal_places !== null 
            ? Number(selectedBiz.decimal_places) 
            : 2;
          const safeDec = [2, 3, 4].includes(dec) ? dec : 2;
          localStorage.setItem("currencyDecimals", safeDec);
        }

        showToast({ success: true, message: "Business switched successfully" });
        setIsModalOpen(false);
        // Point to business page
        window.location.href = "/restaurant/business";
      } else {
        showToast({ success: false, message: "Failed to switch business" });
      }
    } catch (error) {
      console.error("Failed to switch business:", error);
      showToast({
        success: false,
        message: "An error occurred while switching",
      });
    }
  };

  return (
    <>
      {/* Always Visible Business Info Section */}
      <div className="w-full mb-2">
        <Link to="/restaurant/editbusiness" className="flex items-center gap-2">
          <FaStore className="text-gray-600" />
          <div>
            <p className="text-sm font-bold">
              {currentBusiness?.business_name || "Your Business"}
            </p>
          
            <p className="text-xs ">
              {currentBusiness?.contact_number || "+91 0000000000"}
            </p>
              <p className="text-sm  font-bold text-black">
             <span>Restaurant Code: {currentBusiness?.restaurant_code} </span>
            </p>
          
          </div>
        </Link>

        {/* Button Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2 w-full">
          <button
            onClick={() => setIsModalOpen(true)}
            className={`bg-primary text-white text-xs px-2 py-2 rounded w-full ${
              locked ? "cursor-not-allowed opacity-50" : ""
            }`}
            disabled={locked}
          >
            Switch Business
          </button>
          <Link
            to="/restaurant/addbusiness"
            className="bg-pink-100 text-primary text-xs px-2 py-2 rounded text-center w-full"
          >
            Create Business
          </Link>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
            >
              <IoClose size={24} />
            </button>

            <h2 className="text-xl font-semibold mb-4 text-center">
              {/* Select Business */}
            </h2>

            {loading ? (
              <p className="text-center text-gray-500">Loading...</p>
            ) : (
              <div className="space-y-3 max-h-96 overflow-y-auto">
                {businesses.map((biz) => (
                  <div
                    key={biz.id}
                    onClick={() => setSelected(biz.id)}
                    className={`flex items-center justify-between p-3 rounded-lg shadow-sm cursor-pointer border transition ${
                      selected === biz.id
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-200 hover:bg-blue-50"
                    }`}
                  >
                    <div className="flex flex-col">
                      <span className="text-gray-800 font-medium">
                        {biz.business_name}
                      </span>
                      {getUserdata("restaurantId") === biz.id && (
                        <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full w-fit mt-1 font-bold">
                          Currently Active
                        </span>
                      )}
                    </div>

                    {/* Radio circle */}
                    <div
                      className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                        selected === biz.id
                          ? "border-blue-600 bg-blue-600"
                          : "border-gray-400"
                      }`}
                    >
                      {selected === biz.id && (
                        <div className="w-2.5 h-2.5 bg-white rounded-full" />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <button
              onClick={handleConfirm}
              className={`mt-6 w-full py-2 rounded transition ${
                selected
                  ? "bg-primary text-white hover:bg-blue-700"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
              disabled={!selected}
            >
              Confirm
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BusinessModal;
